<template>
    <div>
        <v-speed-dial
                v-model="fab"
                bottom
                right
                fixed
                transition="slide-x-reverse-transition"
        > <!-- open-on-hover -->
            <v-btn
                    slot="activator"
                    v-model="fab"
                    color=""
                    dark
                    fab
            >
                <v-icon>fiber_new</v-icon>
                <v-icon>close</v-icon>
            </v-btn>
            <New
                    v-for="(n, i) in news"
                    :key="i"
                    :title="n.title"
                    :description="n.description"
                    :date="n.date"
            ></New>
        </v-speed-dial>
        <div class="counter">
            <v-badge right>
                <span slot="badge">{{ news.length }}</span>
            </v-badge>
        </div>
    </div>
</template>

<script>
import New from './New.vue';

export default {
  components: {
    New,
  },
  data() {
    return {
      fab: false,
      news: [
      ],
    };
  },
  name: 'News',
};
</script>

<style scoped>
    .counter {
        position: fixed;
        right: 35px;
        bottom: 55px;
        z-index: 4;
    }
</style>
